import { useIsSmallDevice } from 'utils/helper-device'
import HelperPlatform from 'utils/helper-platform'
import { FormStyles } from 'styles/components/molecules/Form'
import React from 'react'
import { View } from 'react-native'
import ThemedBlock from 'components/atoms/ThemedBlock'
import { Column, Grid, Row } from 'components/atoms/BootstrapGrid'

const ThemedContainerButton = ({ buttons, children }) => {
	
	const isSmallDevice = useIsSmallDevice();
	
	let content = (
		<View>
			{ children }
			
			<View
				style={ FormStyles.submit }>
				
				{ buttons }
			</View>
		</View>
	)
	
	if( HelperPlatform.isWeb() && !isSmallDevice ) {
		content = (
			<Grid>
				<Row>
					<Column
						style={ FormStyles.fieldsWeb }
						size={ 75 }>
						
						{ children }
					</Column>
					
					<Column
						style={ FormStyles.submit }
						size={ 25 }>
						
						{ buttons }
					</Column>
				</Row>
			</Grid>
		)
	}
	
	return (
		<ThemedBlock
			shadow
			mediumPadding>
			
			{ content }
		</ThemedBlock>
	)
}

export default ThemedContainerButton
